import { Slider, Stack, Typography } from '@mui/material';
import React from 'react';
import QuantityButtonGroup from '../../CustomComponents/QuantityButtonGroup';

function HospitalSiteSettings(props) {
    function handleHighImpactThresholdChange(newValue) {
        props.setHospitalData({
            ...props.hospitalData,
            high_impact_threshold: (newValue / 100)
        });
    }

    function handleOverdueSettingChange(newValue) {
        props.setHospitalData({
            ...props.hospitalData,
            overdue_timer_setting: newValue
        });
    }

    return (
        <Stack p={2} spacing={2}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography variant='normal' sx={{ fontSize: '16px' }}>High Impact Threshold: {Math.round((props.hospitalData.high_impact_threshold) * 100)}%</Typography>
                <Slider value={Math.round((props.hospitalData.high_impact_threshold) * 100)} onChange={(e) => handleHighImpactThresholdChange(e.target.value)} sx={{ maxWidth: '40%' }}/>
            </Stack>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography variant='normal' sx={{ fontSize: '16px' }}>Staff Review Overdue Timer (Default 5 Days): {props.hospitalData.overdue_timer_setting ?? 5}</Typography>
                <QuantityButtonGroup quantity={props.hospitalData.overdue_timer_setting ?? 5} setQuantity={handleOverdueSettingChange}/>
            </Stack>
        </Stack>
    )
}

export default HospitalSiteSettings;
